import { DatePickerTranslations } from './types';

export const defaultTranslations: DatePickerTranslations = {
  placeholder: 'From',
};
